module.exports = __webpack_public_path__ + "static/media/996464.3038137e.png";